export interface IMessageBase {
  showStatus: string;
  showStatusIcon?: string;
  isRtl?: boolean;
  country?: string;
}

/**
 * 商品消息
 */
export interface IGoodsMessage extends IMessageBase {
  goodsId: number;
  goodsName: string;
  imageThumb: string;
  showOriginalPrice: string;
  showPromotePrice: string;
  labels: {
    view: string;
  };
}

/**
 * 订单
 */
export interface IOrderMessage extends IMessageBase {
  orderId: string;
  itemList: IOrderItem[];
  showTotalAmount: string;
  placeTime: number;
  labels: {
    orderID?: string;
    orderDate?: string;
    total?: string;
    view?: string;
    viewMore?: string;
  };
}

/**
 * 订单商品信息
 */
export interface IOrderItem {
  goodsId: number;
  skuId: number;
  skuValue: string;
  skuValues: {
    pic?: string;
    value?: string;
  }[];
  title: string;
  coverImage: string;
  showDiscountPrice: string;
  count: number;
}

/**
 * 卡片分为: 商品卡片 订单卡片 逆向卡片  
 * 其中逆向卡片包括以下类型:  
 * 退货 取消 RTO 仅退款
 */
export enum AfterSalesType {
  /** 取消 */
  CANCEL = 1,
  /** 仅退款 */
  RETURN = 2,
  /** RTO */
  RTO = 3,
  /** 仅退款 */
  ONLY_REFUND = 4,
}

export enum RefundStatus {
  REFUND_PROCESSING = 'PROCESSING',
  REFUND_PROCESSED = 'SUCCEEDED',
  REFUND_FAILED = 'FAILED',
  OTHER = 'OTHER',
}

export type ICardMessageData = IGoodsMessage | IOrderMessage | IReverseOrderMessage;

/**
 * 退货订单
 */
export interface IReverseOrderMessage extends IMessageBase {
  reverseId: string;
  orderId: string;
  reverseItemList: IReverseOrder[];
  applyTime: number;
  labels: {
    applicationTime?: string;
    view?: string;
    returnMode: string;
    returnTimeline: string;
    total: string;
    viewMore: string;
  };
  afterSalesType: AfterSalesType;
  afterSalesTypeTxt: string;
  refundMode?: { icon?: string; content: string }[];
  refundTimeline: string;
  refundStatus: RefundStatus;
  /** 当前单子里所有品的实际退货数量和 */
  totalActualReturnQty: number;
  /** 总价 */
  totalAmountTxt: string;
}

export interface RefundIntentionItem {
  skuId: string;
  returnable: boolean;
  // 商品标题
  title: string;
  goodsId: number;
  // 商品数量
  count: number;
  // 商品封面图
  coverImage: string;
  // 价格
  discountPriceText: string;
  specification: { pic: string; value: string }[];
  reason?: {
    name: string;
    description: {
      id: number;
      name: string;
    }[];
  }[];
}

/**
 * 选择订单和商品并退货
 */
export interface IRefundIntentionCardMessage extends IMessageBase {
  isRtl: boolean;
  // 卡片标题：I want to return this item
  title: string;
  orderId: string;
  // 退货商品列表，商品结构此处省略，follow服务端下发商品结构
  skuList: RefundIntentionItem[];
  // 退货图片列表
  returnCredentials: string[];
  plan: {
    id: number;
    title: string;
    note: string;
  };
  returnReason: {
    id: number;
    categoryId: number;
    categoryName: string;
    reasonName: string;
  };
  labels: {
    view: string;
    returnReason: string;
    returnPlan: string;
    returnCredentials: string;
  }
}

/**
 * 退货订单商品
 */
export interface IReverseOrder {
  count: number;
  coverImage: string;
  goodsId: number;
  goodsName: string;
  showDiscountPrice: string;
  skuId: number;
  skuValue: string;
  skuValues: {
    keyId?: number | null;
    pic?: string | null;
    value?: string | null;
  }[];
}

/**
 * 订单列表消息
 */
export interface IOrderListMessage {
  actions: IOrderAction[];
  title: string;
}

/**
 * 订单列表动作
 */
export interface IOrderAction {
  actionData: any;
  actionName: string;
}
